export const iconFontAwesomeShoppingBarcode = (
	<i className="fa-solid fa-barcode"></i>
);
